/**
 * Custom Avatar Component
 * Extends Ant Design Avatar with custom styling
 */

import { Avatar as AntAvatar, AvatarProps } from 'antd';
import { UserOutlined } from '@ant-design/icons';
import classNames from 'classnames';
import './CustomAvatar.scss';

export interface CustomAvatarProps extends AvatarProps {
  /** Avatar variant */
  variant?: 'default' | 'square' | 'rounded';
  /** Status indicator */
  status?: 'online' | 'offline' | 'away' | 'busy';
}

/**
 * CustomAvatar Component
 */
export const CustomAvatar: React.FC<CustomAvatarProps> = ({
  variant = 'default',
  status,
  className,
  icon,
  ...rest
}) => {
  const avatarClasses = classNames(
    'custom-avatar',
    `custom-avatar--${variant}`,
    {
      [`custom-avatar--status-${status}`]: status,
    },
    className
  );

  return (
    <div className="custom-avatar-wrapper">
      <AntAvatar {...rest} icon={icon || <UserOutlined />} className={avatarClasses} />
      {status && <span className={`custom-avatar__status custom-avatar__status--${status}`} />}
    </div>
  );
};

/**
 * CustomAvatarGroup Component
 */
export const CustomAvatarGroup = AntAvatar.Group;

export default CustomAvatar;

